import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReferencesComponent } from './references/references.component';
import { REFERENCES_PATHS } from './references';
import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: REFERENCES_PATHS.references,
    component: ReferencesComponent,
    canActivate: [AuthGuard],
    data: { animation: 'ReferencesPage', permission: null },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReferencesRoutingModule {}
